import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from 'src/app/generico/servicio/consume-credenciales.service';
import { MensajeService } from 'src/app/generico/servicio/mensaje.service';
import { SpinnerService } from 'src/app/spinner.service';
import { HttpParams } from '@angular/common/http';

export interface AppContrato{
  id_aplicacion : number;
  txt_descripcion : string;
  num_cantidad_usuarios : number;
  ind_activo : boolean;
  ind_full_acceso : boolean;
  ind_sin_limite : boolean;
  short_name : string;
  ind_instancia : number;
}

export interface Contrato {
  fk_cliente : number;
  fk_tipo_contrato :number;
  fec_inicio : string ;
  fec_fin : string ;
  num_vlr_contrato : number;
  txt_objeto : string;
  ind_activo : boolean;
  id_contrato? : number;
  fec_ini_prorroga : string;
  json_aplicacion? : AppContrato;
  num_contrato? : string
}

@Injectable({
  providedIn: 'root'
})



export class ContratoService {


  json_contrato : Contrato;
  json_tipo_contato : any;
  fec_inicio_prorroga : Date;
  fec_fin_prorroga : Date;
  dialog_prorrogas : any;
  json_apliciones : any;
  json_accesos_disponibles : any;
  json_accesos_adicionados : any;
  disabled : boolean = false; //determina si los formulario de contrato se deben ver en modo lectura

  constructor(private cred_serv : ConsumeCredencialesService,
              private msj_serv : MensajeService,
              private spiner : SpinnerService) { }

  /**
   * Funcion que crea un contrato
   * @param json_data inforcion del contrato a crear
   */
  public async crear_contrato(json_data){

    const promesa = this.cred_serv.post('contratos/admincontrato', json_data).toPromise();

    await promesa.then(
      (data : any) =>{

        this.spiner.spin$.next(false);

        let tipo_mensaje = this.msj_serv.TIPO_OK;

        if (data.code > 0 ){
          tipo_mensaje = this.msj_serv.TIPO_ERROR;
        }else{
          this.json_contrato = json_data;
          this.json_contrato.id_contrato = data.data.id_contrato;
        }

        this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);
      }
    );
  }

  /**
   * Consulta el tipo de contrato 
   */
  public async obtener_tipo_contrato() {
    const promesa = this.cred_serv.get('contratos/admincontrato/tipo-contrato').toPromise();
    await promesa.then(
      (data : any) =>{
        this.spiner.spin$.next(false);
        if (data.code > 0 ){
          this.msj_serv.ver_mensaje(data.msg, '', this.msj_serv.TIPO_ERROR);
        }else{
          this.json_tipo_contato = data.data;
        }

      }
    );
  }

  /**
   * Funcion que se encarga de actualizar un contro.
   * @param id_contrato identificador del contrato a actulizar
   * @param data_form datos que se actualizaran del contrato
   */
  public actualizar_contrato(id_contrato, data_form){
    this.cred_serv
        .put('contratos/admincontrato/'+id_contrato, data_form)
        .subscribe(
          (data : any)=>{
            this.spiner.spin$.next(false);
            let tipo_mensaje = this.msj_serv.TIPO_OK;

            if (data.code > 0 ){
              tipo_mensaje = this.msj_serv.TIPO_ERROR;
            }

            this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);
          }
        );
  }


  /**
   * Funcion que consulta las aplicaciones registradas.
   */
  public async consultar_aplicaciones(){
    const promesa = this.cred_serv.get('contratos/admincontrato/aplicaciones').toPromise();

    await promesa.then(
      (data : any )=>{

        this.spiner.spin$.next(false);
        if (data.code > 0 ){
          this.msj_serv.ver_mensaje(data.msg, '', this.msj_serv.TIPO_ERROR);
        }else{
          this.json_apliciones = data.data;
        }

      }
    );
  }

  /**
   * asocia una aplicacion al contrato.
   * @param data_form datos de la aplicacion a osociar
   */
  public asociar_app(data_form, data_accesos){

    this.cred_serv
        .post('contratos/admincontrato/app', data_form)
        .subscribe(
          (data : any) =>{

            this.spiner.spin$.next(false);    
            let tipo_mensaje = this.msj_serv.TIPO_OK;
    
            if (data.code > 0 ){
              tipo_mensaje = this.msj_serv.TIPO_ERROR;
              this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);
            }else{
              data_accesos['fk_contrato'] = this.json_contrato.id_contrato;
              this.json_contrato.json_aplicacion = data_form;
              this.json_contrato.json_aplicacion.id_aplicacion = data_form.fk_aplicacion;
              this.gestionar_accesos(data_accesos);
            }
          }
        );

  }

  public async actualizar_appcontrato(data_from, data_accesos){
    const promesa = this.cred_serv.put('contratos/admincontrato/app', data_from).toPromise();

    await promesa.then(
      (data : any) =>{

        this.spiner.spin$.next(false);    
        let tipo_mensaje = this.msj_serv.TIPO_OK;

        if (data.code > 0 ){
          tipo_mensaje = this.msj_serv.TIPO_ERROR;
          this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);
        }else{
          this.json_contrato.json_aplicacion = data_from;
          this.json_contrato.json_aplicacion.id_aplicacion = data_from.fk_aplicacion;
          data_accesos['fk_contrato'] = this.json_contrato.id_contrato;
          this.gestionar_accesos(data_accesos);
          
        }    
      }
    );
  }

  /**
   * Consulta lo accesos disponiblres y adicionados de un contrato
   */
  public async consultar_accesos(fk_contrato : string, ind_adicionado : string, ind_menu : string, fk_modulo : string, ind_acciones:string){

    let params_http = new HttpParams().set('fk_contrato', fk_contrato)
                                      .set('ind_adicionado',ind_adicionado)
                                      .set('ind_menu',ind_menu)
                                      .set('fk_modulo',fk_modulo)
                                      .set('ind_acciones',ind_acciones);


    const promesa = this.cred_serv.get('contratos/admincontrato/app/accesos', params_http).toPromise();

    await promesa.then(
      (data :any) =>{

        this.spiner.spin$.next(false);    
        let tipo_mensaje = this.msj_serv.TIPO_OK;

        if (data.code > 0 ){
          tipo_mensaje = this.msj_serv.TIPO_ERROR;
          this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);
        }else{
          if (ind_adicionado == '0'){
            this.json_accesos_disponibles = data.data;
          }else{
            this.json_accesos_adicionados = data.data;
          }
        }    

      }
    );
  }

  /**
   * Gestiona los accesos de un contrato a un aplicacion.
   */
  public gestionar_accesos(data_accesos){

    this.cred_serv
        .post('contratos/admincontrato/app/accesos', data_accesos)
        .subscribe(
          (data : any) =>{
            this.spiner.spin$.next(false);
            
            let tipo_mensaje = this.msj_serv.TIPO_OK;
            if (data.code > 0 ){
              tipo_mensaje = this.msj_serv.TIPO_ERROR;          
            }
            
            this.msj_serv.ver_mensaje(data.msg, '', tipo_mensaje);
          }
        );



  }
  
}
